import { Box, Flex, Text } from '@chakra-ui/react';
import { SlideKind } from '@duke-hq/svc-api-db';
import { UnitAssessmentSlides } from '../types';
import { DukeTiptapEditor } from '@duke-hq/ui/components/DukeTiptapEditor/DukeTiptapEditor';
import { Trans } from '@lingui/react/macro';

type OpenQuestionPropTypes = {
  slide: Extract<UnitAssessmentSlides[0], { kind: typeof SlideKind.OPEN_QUESTION }>;
};

export function OpenQuestion({ slide }: OpenQuestionPropTypes) {
  return (
    <Flex flexDir="column" alignItems="center">
      <Box w="full" h="full" p="8px">
        <Text fontSize="sm" fontWeight="semibold" color="fg.muted">
          <Trans>Question</Trans>
        </Text>
        <DukeTiptapEditor initialContent={slide.questionContent} readOnly onChange={() => {}} />
      </Box>
      <Box w="full" h="full" bg="bg.subtle" p="8px" borderRadius="8px">
        <Text fontSize="sm" fontWeight="semibold" color="fg.muted">
          <Trans>Hint</Trans>
        </Text>
        <DukeTiptapEditor initialContent={slide.hint} readOnly onChange={() => {}} />
      </Box>
    </Flex>
  );
}
